import type { GetMigrationByIdHeaders, GetMigrationByIdResponse } from "./types";
import axios from "axios";
import api from "../api/axios";
import { ENDPOINTS } from "../api/endpoints";

/**
 * Obtiene los detalles de una migración específica por su ID
 *
 * @param headers Headers requeridos para la solicitud (X-ACCOUNT-ID)
 * @param migrationId ID de la migración a consultar
 * @returns Respuesta con los detalles de la migración
 */
export async function getMigrationById(migrationId: string): Promise<GetMigrationByIdResponse> {
  try {
    // Configurar los headers requeridos
    const requestHeaders = {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      Accept: "application/json",
    };

    // Realizar la solicitud GET
    const response = await api.get(ENDPOINTS.MIGRATION.GET_BY_ID.replace("{migration_id}", migrationId), {
      headers: requestHeaders,
      timeout: 30000, // 30 segundos
    });

    // Devolver la respuesta formateada
    return {
      success: response.data.success,
      status: response.data.status,
      content: response.data.content,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Si es un error 401 (Unauthorized)
      if (error.response?.status === 401) {
        return {
          success: false,
          status: 401,
          error: {
            id: error.response?.data?.data?.id || "unknown",
            code: error.response?.data?.data?.code || "INVALID_CREDENTIALS",
            title: error.response?.data?.data?.title || "Authentication failed",
            detail: error.response?.data?.data?.detail || "Unauthorized. Missing or invalid X-Account-Id",
          },
        };
      }

      // Para otros errores de respuesta
      const errorData = error.response?.data;
      return {
        success: false,
        status: error.response?.status || 500,
        error: {
          id: errorData?.data?.id || "unknown",
          code: errorData?.data?.code || "ERR_UNKNOWN",
          title: errorData?.data?.title || "Error",
          detail: errorData?.data?.detail || "Ocurrió un error al obtener la migración",
        },
      };
    }

    // Para errores no relacionados con Axios
    return {
      success: false,
      status: 500,
      error: {
        id: "unknown",
        code: "ERR_UNKNOWN",
        title: "Error inesperado",
        detail: error instanceof Error ? error.message : "Ocurrió un error inesperado",
      },
    };
  }
}
